import { oneLine } from 'common-tags';

import { Link, RichInline } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeProductBlockProps } from './types';

export const ProductBlock: FunctionComponent<TypeProductBlockProps> = ({
  className = '',
  eyebrow,
  title,
  description,
  link,
  children,
  eyebrowStyleClass,
  titleStyleClass,
  descriptionStyleClass,
  align = 'center',
}: TypeProductBlockProps) => (
  <div className={`flex flex-col gap-8 ${className}`}>
    {(eyebrow || title || description) && (
      <div
        className={`flex flex-col items-start gap-2 ${
          align === 'center' ? 'md:items-center' : ''
        }`}
      >
        {(eyebrow || title) && (
          // Sub-bloque "kicker over headline" (igual que ContentImage /
          // Postales / ListingHeader): `w-fit items-end` ciñe el bloque al
          // título y deja el eyebrow flotando pegado a su borde derecho.
          // Color/familia del eyebrow hardcodeados; la text-style sólo
          // controla tamaño/leading/weight. Renderizamos via RichInline
          // para que `<mark>` y otros tags inline del CMS funcionen.
          <div className="flex w-fit flex-col items-end">
            {eyebrow && (
              <RichInline
                html={eyebrow}
                className={oneLine`font-accent text-primary-500 ${
                  eyebrowStyleClass ?? 'text-base leading-tight md:text-3xl'
                }`}
              />
            )}
            {title && (
              <RichInline
                as="h2"
                html={title}
                className={oneLine`text-headline ${
                  titleStyleClass ?? 'text-headline-h3'
                }`}
              />
            )}
          </div>
        )}
        {description && (
          <span
            className={oneLine`text-body ${
              descriptionStyleClass ?? 'text-body-m md:text-body-l'
            }`}
          >
            {description}
          </span>
        )}
      </div>
    )}

    {children}

    {link && (
      <div className="items-start">
        <Link href={link.href} icon="right">
          {link.label}
        </Link>
      </div>
    )}
  </div>
);

ProductBlock.displayName = 'ProductBlock';
